import { useSelector } from "react-redux";
import { IStoreState } from "../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../hooks";
import React from "react";
import { Grid } from "@mui/material";
import { StandardCellList } from "../../../../components/Standards";
import { formatTime } from "../../../../helpers";
import { IAddGaragePlate } from "../../../../redux/TaskReducer/GaragePlate/garagePlate.types";
import { fetchAddGaragePlateAysnc } from "../../../../redux/TaskReducer/GaragePlate/garagePlateActions";
import { fetchAddInterestedPartyAysnc } from "../../../../redux/TaskReducer/InterestedParty/interestedPartyActions";
import { IAddInterestedParty } from "../../../../redux/TaskReducer/InterestedParty/interestedParty.types";
import { LoadState } from "../../../../constants/enums";
import { PageLoader } from "../../../../components/PageLoader/PageLoader";

export const ViewAddInterestedParty: React.FC<{
  taskCode: string;
}> = (props) => {
  const { taskCode } = props;

  const { data, loading } = useSelector(
    (storeState: IStoreState) =>
      storeState.tasks.interestedParty.addInterestedParty
  );

  const dispatch = useDispatchWrapper();
  const [interestedPartyDetails, setInterestedPartyDetails] =
    React.useState<IAddInterestedParty>();

  React.useEffect(() => {
    dispatch(fetchAddInterestedPartyAysnc(taskCode));
  }, [taskCode]);

  React.useEffect(() => {
    setInterestedPartyDetails(data);
  }, [data]);

  return (
    <PageLoader loading={loading === LoadState.InProgress}>
      {interestedPartyDetails && (
        <Grid container spacing={1} sx={{ mt: 2 }}>
          <Grid item xs={12} lg={12}>
            <StandardCellList
              heading="Customer Information"
              colSize={3}
              list={[
                {
                  heading: "Policy Number",
                  data: {
                    type: "text",
                    value: interestedPartyDetails.policy_number,
                  },
                },
                {
                  heading: "Customer Code",
                  data: {
                    type: "text",
                    value: interestedPartyDetails.customer_code,
                  },
                },
                {
                  heading: "Customer Name",
                  data: {
                    type: "text",
                    value: interestedPartyDetails.customer_name,
                  },
                },
                {
                  heading: "Line of Business",
                  data: {
                    type: "text",
                    value: interestedPartyDetails.line_of_business,
                  },
                },

                {
                  heading: "Policy Type",
                  data: {
                    type: "text",
                    value: interestedPartyDetails.policy_type,
                  },
                },
                {
                  heading: "Branch",
                  data: {
                    type: "text",
                    value: interestedPartyDetails.branch,
                  },
                },
                {
                  heading: "Broker Code",
                  data: {
                    type: "text",
                    value: interestedPartyDetails.broker_code,
                  },
                },
                {
                  heading: "Insurer",
                  data: {
                    type: "text",
                    value: interestedPartyDetails.insurer,
                  },
                },
                {
                  heading: "Producer",
                  data: {
                    type: "text",
                    value: interestedPartyDetails.producer,
                  },
                },
                {
                  heading: "CSR",
                  data: {
                    type: "text",
                    value: interestedPartyDetails.csr,
                  },
                },
              ]}
            />
          </Grid>
          <Grid item xs={12} lg={12}>
            <StandardCellList
              heading="Garage Plate Information"
              colSize={3}
              list={[
                {
                  heading: "Party Code",
                  data: {
                    type: "text",
                    value: interestedPartyDetails.interested_party_code,
                  },
                },
                {
                  heading: "Type",
                  data: {
                    type: "text",
                    value: interestedPartyDetails.type,
                  },
                },
                {
                  heading: "Name",
                  data: {
                    type: "text",
                    value: interestedPartyDetails.name,
                  },
                },
                {
                  heading: "Address",
                  data: {
                    type: "text",
                    value:
                      interestedPartyDetails.address +
                      " " +
                      interestedPartyDetails.unit_or_suite +
                      " " +
                      interestedPartyDetails.city +
                      " " +
                      interestedPartyDetails.province_or_state +
                      " " +
                      interestedPartyDetails.country +
                      " " +
                      interestedPartyDetails.postal_code,
                  },
                },
                {
                  heading: "Effective Date",
                  data: {
                    type: "text",
                    value: interestedPartyDetails.effective_date_of_change,
                  },
                },
                {
                  heading: "Effective Time",
                  data: {
                    type: "text",
                    value: formatTime(
                      interestedPartyDetails.effective_time_of_change.toString()
                    ),
                  },
                },
                {
                  heading: "Details",
                  data: {
                    type: "text",
                    value: interestedPartyDetails.details,
                  },
                },
              ]}
            />
          </Grid>
        </Grid>
      )}
    </PageLoader>
  );
};
